module.exports = __webpack_public_path__ + "img/2025-03-12d_1.d2a02312.jpg";